import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal, DefaultButton, } from '@fluentui/react';
/**
 * Premade button-modal popup combination
 *
 * @constant
 */
export const ModalButton = ({ children, buttonProps, modalProps, buttonAs = DefaultButton, }) => {
    const [open, setOpen] = useState(false);
    const toggle = () => setOpen(o => !o);
    const ButtonType = buttonAs;
    return (_jsxs(_Fragment, { children: [_jsx(Modal, Object.assign({ isOpen: open, onDismiss: toggle }, modalProps, { children: children })), _jsx(ButtonType, Object.assign({}, buttonProps, { onClick: () => toggle() }, { children: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.children }))] }));
};
